require.register("common/directives/checkboxGroupDirective", function(exports, require, module){
  $0
  
});

